import { Outlet } from 'react-router-dom';

const CoursesLayout = () => {
    return <Outlet />;
};

export default CoursesLayout;
